
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[...products]",
      function () {
        return require("private-next-pages/products/[...products].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[...products]"])
      });
    }
  